<app-investment-plan-deposit
  [investmentPlan]="investmentPlan"
  (action)="onActionEmitted($event)"
></app-investment-plan-deposit>
